import { render, staticRenderFns } from "./PostsSendNotification.vue?vue&type=template&id=29fc3305&"
import script from "./PostsSendNotification.vue?vue&type=script&lang=js&"
export * from "./PostsSendNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports